<template>
  <div class="container mt-5">
    <router-link class="float-right" to="/students">
      <i class="fas fa-chevron-left"></i> Regresar
    </router-link>

    <div class="row">
      <div class="col-md-8">
        <h1 class="text-light">
          <i class="fas fa-id-card mr-3"></i>
          {{student.name}} {{student.lastName}}
        </h1>
        <h3 class="" style="margin-left:5rem">
          {{group}} |
          <small>
            Código:
            <b>{{student.code}}</b>
          </small>
        </h3>
      </div>
      <div class="col-md-2">
        <img :src="student.picture" alt="atchecker" :style="{height: pic_height + 'px', transform: rotation }">
      </div>
    </div>

    <div class="row mt-5 text-light">
      <div class="col-12">
        <h3 class="text-light">Reporte de Asistencia</h3>
      </div>
      <div class="col-md-3 col-6">
        <b>Fecha Inicial</b>
        <input type="date" v-model="startingDate" class="form-control" />
      </div>
      <div class="col-md-3 col-6">
        <b>Fecha Final</b>
        <input type="date" v-model="endingDate" class="form-control" />
      </div>
      <div class="col">
        <br />
        <button @click="getAttendance()" class="btn btn-dark">
          Generar Reporte
          <i class="fas fa-chart-bar ml-2"></i>
        </button>
        <button onclick="window.print()" v-if="items.length >0" class="ml-2 btn btn-dark">
          Imprimir
          <i class="fas fa-print ml-2"></i>
        </button>
      </div>
    </div>

    <div class="row mt-3 mb-5 ">
      <div class="col">
        <table class="table table-hover table-sm table-bordered table-striped shadow ">
          <thead class="bg-balck text-light">
            <th>Fecha</th>
            <th>Hora</th>
            <th>Evento</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td :class="[ item.event=='in' ? 'text-light' :'text-secondary']">{{ new Date(item.date).toDateString("es", options)}}</td>
              <!-- <td :class="[ item.event=='in' ? 'text-primary' :'text-secondary']">{{ item.date.substr(0,10) }}</td> -->
              <td :class="[ item.event=='in' ? 'text-light' :'text-secondary']">{{ item.time.substr(0,5) }}</td>
              <!-- <td :class="[ item.event=='in' ? 'text-light' :'text-secondary']">{{ new Date(item.date).toTimeString().substring(0,5) }}</td> -->
              <!-- <td :class="[ item.event=='in' ? 'text-light' :'text-secondary']">{{ item.date.substr(11,5) }}</td> -->
              <td>
                <span v-if="item.event=='in'" class="text-light">
                  <i class="fas fa-thumbtack mr-3"></i> <i>entrada</i> 
                </span>
                <span v-if="item.event=='out'" class="text-secondary ">
                  <i class="fas fa-sign-out-alt mr-3"></i> <i>salida</i> 
                </span>
              </td>
              <td>{{item.mark}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      student: {},
      url: this.$store.state.url,
      group: "",
      items: [],
      startingDate: null,
      endingDate: null,
      options : { year: 'numeric', month: 'long', day: 'numeric' },
      pic_height: this.$store.state.pic_height,
      pic_width: this.$store.state.pic_width,
      rotation: this.$store.state.rotation,
    };
  },
  mounted() {
    this.getStudent();
    this.startingDate = this.parseDate(new Date())
    this.endingDate = this.parseDate(new Date())    
  },
  methods: {
    async getStudent() {
      let req = await fetch(this.url + "student/" + this.id);
      this.student = await req.json();
      req = await fetch(this.url + "group/" + this.student.groupId);
      let group = await req.json();
      this.group = group.name;
    },
    async getAttendance() {
      let startingDate = this.startingDate;
      let endingDate = this.endingDate;
      let req = await fetch(
        this.url +
          "getattendance/" +
          this.student.token +
          "/" +
          startingDate +
          "/" +
          endingDate
      );
      this.items = await req.json();
    },

    parseDate(value) {
        let d = value.getDate()
        if (d < 10) { d = "0" + d}
        let m = value.getMonth() + 1
        if (m < 10) { m = "0" + m}
        let y = value.getFullYear() 
      return y + "-" + m + "-" + d
      ;
    }
  }
};
</script>

<style scoped>
td{padding: 8px !important;}
th{padding: 8px 15px !important;}
.rotate{transform: rotate(-90deg);}
</style>